module.exports = __webpack_public_path__ + "img/new_61.0fe8e4b9.jpg";